// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__+yhQW","value":"Radio_value__bkRiH","label":"Radio_label__M7TOd","input":"Radio_input__ZG4T9"};